/* e.g. import { ROUTE_NAME } from '@/constants/route.constants' */
const ROUTE_NAME = Object.freeze({
  HOME: 'home',
  /* BANK */
  PAGE_NOT_AVAILABLE: 'page-not-available',
  FUNDS: 'funds',
  DEPOSIT: 'deposit',
  DEPOSIT_SUCCESS: 'deposit-success',
  WITHDRAWAL: 'withdrawal',
  TRANSACTION: 'transaction',
  PROCESS_TRANSACTION: 'process-transaction',
  PAY_SECURE: 'pay-secure',
  TRANSFER: 'transfer',
  CLAIM_VOUCHER: 'claim-voucher',
  VIP: 'vip',
  GRAB_COIN: 'grab-coin',
  /* PAYMENT */
  VENDOR_POPUP: 'vendor-popup',
  WOF: 'nspin',
  MWOF: 'mnspin',
  /* PROFILE */
  PROFILE_MENU: 'profile-menu',
  PROFILE_LOGOUT: 'profile-logout',
  PROFILE: 'profile',
  PERSONAL: 'personal',
  BANK_ACCOUNT: 'bank-account',
  INBOX: 'inbox',
  RESET_PASSWORD: 'reset-password',
  CHANGE_PASSWORD: 'change-password',
  CONTACT_VERIFICATION: 'contact-verification',
  TRANSACTION_HISTORY: 'transaction-history',
  REWARDS: 'rewards',
  REFERRAL_BONUS: 'referral-bonus',
  APPLY_AGENT: 'apply-agent',
  /* BONUS */
  BONUS: 'promotion',
  BONUS_IN_PROGRESS: 'bonus-in-progress',
  BONUS_HISTORY: 'bonus-history',
  TRANSFER_HISTORY: 'transfer-history',
  BETTING_HISTORY: 'betting-history',
  TURNOVER_RECORD: 'turnover_record',
  PLAYER_HISTORY: 'player-history',
  /* OTHER */
  ANNOUNCEMENT: 'announcement',
  /* SPORTSBOOK */
  SPORTSBOOK: 'sportsbook',
  SPORTSBOOK_BY_PROVIDER: 'sportsbookByProvider',
  /* CASINO */
  CASINO: 'casino',
  CASINO_BY_PROVIDER: 'casinoByProvider',
  /* ESPORTS */
  ESPORTS: 'esports',
  ESPORTS_BY_PROVIDER: 'esportsByProvider',
  /* FISHING */
  FISHING: 'fishing',
  FISHING_BY_PROVIDER: 'fishingByProvider',
  /* SLOT */
  SLOT: 'slot',
  SLOT_BY_PROVIDER: 'slotByProvider',
  SLOT_BY_PROVIDER_AND_GAMENAME: 'slotByProviderAndGameName',
  SLOT_BY_GAMENAME: 'slotByGameName',
  /* SPECIAL */
  SPECIAL: 'special',
  SPECIAL_BY_PROVIDER: 'specialByProvider',
  SHORTCUT: 'shortcut',
  /* TABLE GAME*/
  TABLE_GAMES: 'tablegames',
  TABLE_GAMES_BY_PROVIDER: 'tablegamesByProvider',
  /* LOTTERY */
  LOTTERY: 'lottery',
  LOTTERY_BY_PROVIDER: 'lotteryByProvider',
  /* CRASH */
  CRASH: 'crash',
  CRASH_BY_PROVIDER: 'crashByProvider',
  /* ORIGINALS */
  ORIGINALS: 'originals',
  ORIGINALS_BY_PROVIDER: 'originalsByProvider',
  /* CRICKET GAME*/
  CRICKET: 'cricket',
  CRICKET_BY_PROVIDER: 'cricketByProvider',
  /* GAME */
  LAUNCH_GAME_LOBBY: 'gameLobby',
  /* PROMOTION */
  PROMOTION: 'promotion',
  PROMOTION_IN_PROGRESS: 'promotion-in-progress',
  PROMOTION_HISTORY: 'promotion-history',
  /* REWARDS */
  DAILYCHECKIN: 'dailycheckin',
  REWARDS_BY_TYPE: 'rewardsByType',
  DAILY_CHECKIN: 'daily-checkin',
  /* REFERRAL */
  REFERRAL: 'referral',
  REFERRAL_TIER: 'tier',
  REFERRAL_SUMMARY: 'summary',
  REFERRAL_REPORT: 'report',
  REFERRAL_HISTORY: 'history',
  REFERRAL_DOWNLINE_REPORT: 'downlinereport',
  REFERRAL_STATUS: 'status',
  /* AFFILIATE */
  AFFILIATE_HOME: 'affiliate-home',
  AFFILIATE_MEMBER_REPORT: 'affilaite-member',
  AFFILIATE_MEMBER_DETAIL_REPORT: 'affilaite-detail-member',
  AFFILIATE_GAME_REPORT: 'affiliate-game-report',
  AFFILIATE_AGENT_REPORT: 'affiliate-agent-report',
  AFFILIATE_LINK: 'affilaite-link',
  AFFILIATE_BANK_ACCOUNT: 'affilaite-bank-account',
  AFFILIATE_TRANSACTION: 'affilaite-transaction',
  AFFILIATE_WITHDRAWAL: 'affilaite-withdrawal',
  VIPTIER: 'vip-tier',
  /* INFO */
  FAQ: 'faq',
  ABOUT_US: 'aboutUs',
  CONTACT_US: 'contactUs',
  TNC: 'termsAndCondition',
  /* ERROR */
  ERROR_403: 'ip-restriction',
  ERROR_404: 'page-not-found',
  REGISTER_MOBILE: 'register-mobile',
  REGISTER: 'register',
  REGISTER_NO_LANG: 'register_no_lang',
  /* INSTANT REBATE */
  REBATE: 'instantRebate',
  REBATE_HISTORY: 'rebateHistory',
  REBATE_HISTORY_DETAIL: 'rebateHistoryDetail',
  REGISTER_LANDING_PAGE: 'register-landing'
})

export { ROUTE_NAME }
